module.exports = __webpack_public_path__ + "img/foto_lih3_small.26e39174.webp";